import { Component, OnInit, Inject , ElementRef, AfterViewInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnalyticsService } from '@services/analytics.service';

@Component({
  selector: 'smione-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit , AfterViewInit{
  txtSuccess:string;
  componentName : string = 'SuccessModal';
  constructor(
    public dialogRef: MatDialogRef<SuccessModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private analyticsService: AnalyticsService,
    private elementRef: ElementRef
  ) { 
    console.log(this.dialogData); 
    if(this.dialogData.isAutoClose)  
      setTimeout(()=>{ this.close(); },5000)    
  }

  ngOnInit() {}

   ngAfterViewInit() {
    // Set aria-label on the dialog container for accessibility
    // Use afterOpened to ensure the dialog container is fully rendered
    this.dialogRef.afterOpened().subscribe(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer) {
        dialogContainer.setAttribute('aria-label', 'Success dialog');
      }
    });
   
    // Fallback: also try in ngAfterViewInit in case afterOpened already fired
    setTimeout(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer && !dialogContainer.getAttribute('aria-label')) {
        dialogContainer.setAttribute('aria-label', 'Success dialog');
      }
    }, 0);
  }



  close(data?){
    this.analyticsService.gtag(this.componentName, `close`);
    this.dialogRef.close(data);
  }
}
